export const environment = {
    production: false,
    appTitle:'',
    api_url:'https://osppayoragentdev.ospbiz.com',
    socket_url:'wss://wowkx43c0d.execute-api.us-east-2.amazonaws.com/development',
    
}